import { useMemo } from 'react';
import { useAssignedAppTypeContext, useVivliConfigContext } from '@vivli/core/infrastructure/context';

export const useDataPackageFileTypes = () => {
    const { isAmr } = useAssignedAppTypeContext();
    const vivliConfig = useVivliConfigContext();

    const requiredTypes = useMemo(() => {
        if (isAmr) {
            return vivliConfig?.ipdFileTypes?.filter((x) => x.requiredAmr).map((x) => x.fileType);
        }
        return vivliConfig?.ipdFileTypes?.filter((x) => x.requiredCtBasic).map((x) => x.fileType);
    }, [vivliConfig?.ipdFileTypes, isAmr]);

    const availableTypes = useMemo(() => {
        if (isAmr) {
            return vivliConfig?.ipdFileTypes?.filter((x) => x.includeAmr).map((x) => x.fileType);
        }
        const available = vivliConfig?.ipdFileTypes?.filter((x) => x.includeCt).map((x) => x.fileType);
        available?.splice(0, 0, 'Unknown');
        return available;
    }, [vivliConfig?.ipdFileTypes, isAmr]);

    const hideForPubliclyAvailableTypes = useMemo(() => {
        return vivliConfig?.ipdFileTypes?.filter((t) => !t.publicAccessAllowable).map((t) => t.fileType);
    }, [vivliConfig?.ipdFileTypes]);

    return {
        hideForPubliclyAvailableTypes,
        availableTypes,
        requiredTypes,
    };
};
